var map = {
	"./CarouselBook2": 3569,
	"./CarouselBook2.css": 4390,
	"./CarouselBook2.js": 3569,
	"./assets/Held.jpeg": 4692,
	"./assets/aColdSpell.jpeg": 3849,
	"./assets/book-banner.jpg": 1786,
	"./assets/book-banner111.jpg": 1595,
	"./assets/book-banner22.jpg": 2899,
	"./assets/book-banner33.jpg": 6259,
	"./assets/gioiThieu.webp": 1058,
	"./assets/intro.jpg": 9754,
	"./assets/intro2.jpg": 2911,
	"./assets/mission.jpg": 8183,
	"./assets/mission.webp": 8777,
	"./assets/theRestIsHistory.jpeg": 1033,
	"./assets/theRestIsHistory2.jpeg": 4838,
	"./assets/theTempleOfFortuna.jpeg": 5207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6444;